import React, { FC } from 'react';
import styles from './styles.module.scss';

interface IProps {}

const Filler: FC<IProps> = () => <div className={styles.filler} />;

export { Filler };
